import { createFileRoute } from '@tanstack/react-router';
import { SharedProject } from '../share/SharedProject';

export const Route = createFileRoute('/share/$shareId')({
  component: ShareRoute,
});

function ShareRoute() {
  const { shareId } = Route.useParams();
  return <SharedProject shareId={shareId} />;
}
